/*
 * Helper to allow importing of the env config.
 *    import config from 'configs/env-config';
 *        OR
 *    ENVConfig.VARIABLE // Auto import.
 */

const config = (function (env) {
    switch (env) {
        case 'production':
            return {
                APP_HOST: '/api',
                WSS_HOST: 'wss://psp.corefact.com/ws',
                ENDPOINTS: {
                    MANAGE: '/manage/v2',
                    VENDOR: '/vendor/v1',
                },
            };
        case 'staging':
            return {
                APP_HOST: '/api',
                WSS_HOST: 'wss://psp-staging.corefact.com/ws',
                ENDPOINTS: {
                    MANAGE: '/manage/v2',
                    VENDOR: '/vendor/v1',
                },
            };
        case 'station':
            return {
                APP_HOST: 'http://0.0.0.0:6280/api',
                WSS_HOST: 'ws://localhost:6280/ws',
                ENDPOINTS: {
                    MANAGE: '/manage/v2',
                    VENDOR: '/vendor/v1',
                },
            };
        case 'testing':
        case 'development':
        default:
            return {
                APP_HOST: 'http://0.0.0.0:8080/api',
                WSS_HOST: 'ws://localhost:8291/ws',
                ENDPOINTS: {
                    MANAGE: '/manage/v2',
                    VENDOR: '/vendor/v1',
                },
            };
    }
})(process.env.NODE_ENV);

export default {
    ...(process.env.CONFIG || {}),
    ...config,
};
